'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSupportedLocale = exports.getDisplayMessages = exports.configureLocale = exports.translations = exports.supportedLocales = exports.DEFAULT_LOCALE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _bgBG = require('./translations/bg-BG.json');

var _bgBG2 = _interopRequireDefault(_bgBG);

var _csCZ = require('./translations/cs-CZ.json');

var _csCZ2 = _interopRequireDefault(_csCZ);

var _daDK = require('./translations/da-DK.json');

var _daDK2 = _interopRequireDefault(_daDK);

var _deDE = require('./translations/de-DE.json');

var _deDE2 = _interopRequireDefault(_deDE);

var _elGR = require('./translations/el-GR.json');

var _elGR2 = _interopRequireDefault(_elGR);

var _enGB = require('./translations/en-GB.json');

var _enGB2 = _interopRequireDefault(_enGB);

var _esES = require('./translations/es-ES.json');

var _esES2 = _interopRequireDefault(_esES);

var _etEE = require('./translations/et-EE.json');

var _etEE2 = _interopRequireDefault(_etEE);

var _fiFI = require('./translations/fi-FI.json');

var _fiFI2 = _interopRequireDefault(_fiFI);

var _frFR = require('./translations/fr-FR.json');

var _frFR2 = _interopRequireDefault(_frFR);

var _hrHR = require('./translations/hr-HR.json');

var _hrHR2 = _interopRequireDefault(_hrHR);

var _huHU = require('./translations/hu-HU.json');

var _huHU2 = _interopRequireDefault(_huHU);

var _itIT = require('./translations/it-IT.json');

var _itIT2 = _interopRequireDefault(_itIT);

var _ltLT = require('./translations/lt-LT.json');

var _ltLT2 = _interopRequireDefault(_ltLT);

var _lvLV = require('./translations/lv-LV.json');

var _lvLV2 = _interopRequireDefault(_lvLV);

var _nbNO = require('./translations/nb-NO.json');

var _nbNO2 = _interopRequireDefault(_nbNO);

var _nlNL = require('./translations/nl-NL.json');

var _nlNL2 = _interopRequireDefault(_nlNL);

var _plPL = require('./translations/pl-PL.json');

var _plPL2 = _interopRequireDefault(_plPL);

var _roRO = require('./translations/ro-RO.json');

var _roRO2 = _interopRequireDefault(_roRO);

var _skSK = require('./translations/sk-SK.json');

var _skSK2 = _interopRequireDefault(_skSK);

var _svSE = require('./translations/sv-SE.json');

var _svSE2 = _interopRequireDefault(_svSE);

var _slSI = require('./translations/sl-SI.json');

var _slSI2 = _interopRequireDefault(_slSI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en-GB';

var supportedLocales = exports.supportedLocales = ['bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'et', 'fi', 'fr', 'hr', 'hu', 'it', 'lt', 'lv', 'nb', 'nl', 'pl', 'ro', 'sk', 'sv', 'sl', 'bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'en-GB', 'es-ES', 'et-EE', 'fi-FI', 'fr-FR', 'hr-HR', 'hu-HU', 'it-IT', 'lt-LT', 'lv-LV', 'nb-NO', 'nl-NL', 'pl-PL', 'ro-RO', 'sk-SK', 'sv-SE', 'sl-SI'];

var translations = exports.translations = {
    // ...baseTranslations,
    bg: _bgBG2.default,
    cs: _csCZ2.default,
    da: _daDK2.default,
    de: _deDE2.default,
    el: _elGR2.default,
    en: _enGB2.default,
    es: _esES2.default,
    et: _etEE2.default,
    fi: _fiFI2.default,
    fr: _frFR2.default,
    hr: _hrHR2.default,
    hu: _huHU2.default,
    it: _itIT2.default,
    lt: _ltLT2.default,
    lv: _lvLV2.default,
    nb: _nbNO2.default,
    nl: _nlNL2.default,
    pl: _plPL2.default,
    ro: _roRO2.default,
    sk: _skSK2.default,
    sv: _svSE2.default,
    sl: _slSI2.default
};

var configureLocale = exports.configureLocale = function configureLocale(translationsLookupTable) {

    var getTranslation = function getTranslation(locale) {
        var _locale$split = locale.split('-'),
            _locale$split2 = _slicedToArray(_locale$split, 1),
            lang = _locale$split2[0];

        return translationsLookupTable[lang];
    };

    return {
        getDisplayMessages: getTranslation,
        getSupportedLocale: function getSupportedLocale(locale) {
            return supportedLocales.includes(locale) ? locale : DEFAULT_LOCALE;
        }
    };
};

var _configureLocale = configureLocale(translations),
    getDisplayMessages = _configureLocale.getDisplayMessages,
    getSupportedLocale = _configureLocale.getSupportedLocale;

exports.getDisplayMessages = getDisplayMessages;
exports.getSupportedLocale = getSupportedLocale;